//import { createStyles, makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import ErrorIcon from '@mui/icons-material/Error';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import DatePicker from '@mui/lab/DatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import AdapterDateFns from '@date-io/date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  Alert,
  DialogActions,
  DialogContent,
  DialogContentText,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Paper,
  Slide,
  Snackbar,
  styled
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import Menu from '@mui/material/Menu';
import Pagination from '@mui/material/Pagination';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { Theme, useTheme } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch } from 'react-redux';
import apiConfig from 'src/api/APIConfig';
import { useUser } from 'src/components/common/hooks/useUser';
import { store, useAppSelector } from 'src/store';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import AssociatedDocuments from './AssociatedDocuments';
import Progress from './Progress';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight: personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium
  };
}

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

interface handleChange {
  children?: React.ReactNode;
  event: any;
  value: number;
}

const currencies = [
  {
    value: 'USD',
    label: 'Study'
  },
  {
    value: 'EUR',
    label: 'Study'
  }
];

const bull = (
  <Box component="span" sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}>
    •
  </Box>
);
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}));

const BootstrapDialogTitle = (props: { [x: string]: any; children: any; onClose: any }) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any }) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

export interface ICollapseItem {
  [key: string]: boolean;
}
export const expandAllTxt = 'EXPAND ALL';
export const collapseAllTxt = 'COLLAPSE ALL';

export const QueryModal: React.FunctionComponent<any> = ({
  gridRows,
  selectedRowId,
  handleClose,
  getData,
  studyId,
  country,
  siteId
}) => {
  const selectedMilestone = gridRows.filter((item: any) => item.milestone_id === selectedRowId)[0];
  const [msgDetails, setMsgDetails] = useState('');
  const [severity, setSeverity] = useState(true);
  const [showMsg, setShowMsg] = useState(false);
  const theme = useTheme();
  const milestoneStatusList = ['Not applicable', 'Planned', 'In progress', 'Completed', 'Overdue', 'On hold'];
  const usersList: string[] = ['SYSTEM', 'udya', 'Jane Jo', 'Smruthi Panyam', 'Loren Ipsum'];
  const [updated, setUpdated] = useState(false);
  const { userName } = useUser();
  //const { checkPermission } = usePermissionWrapper();
  const [isDisable, setIsDisble] = useState(false);
  const dispatch = useDispatch();
  // console.log(isDisable, checkPermission('site_milestones_update'))
  const { preferedFormatForDatePicker, preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const exportDateFormat = userPreferedDateFormat.includes('/')
    ? userPreferedDateFormat.replaceAll('/', '_')
    : userPreferedDateFormat.replaceAll('-', '_');
  // const useStyles = makeStyles(theme =>
  //   createStyles({
  //     previewChip: {
  //       minWidth: 160,
  //       maxWidth: 210
  //     }
  //   })
  // );

  const [value, setValue] = React.useState(0);

  const handleChangeUsers = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue);
  };

  const [editStartDateAdjusted, setEditStartDateAdjusted] = useState(false);
  const [comments, setComments] = useState(selectedMilestone.milestone_comments);
  const [editEndDateAdjusted, setEditEndDateAdjusted] = useState(false);
  const [editMilestoneStatus, setEditMilestoneStatus] = useState(false);
  const [editAssignedTo, setEditAssignedTo] = useState(false);
  const [endDateAdjusted, setEndDateAdjusted] = useState(selectedMilestone.end_date_adjusted);
  const [milestoneStatus, setMilestoneStatus] = useState(selectedMilestone.milestone_status);
  const [assignedTo, setAssignedTo] = useState(selectedMilestone.assigned_to);
  const [updatedMilestoneStatus, setUpdatedMilestoneStatus] = useState<any>({
    updated_by: userName
  });
  const [updatedAssignedTo, setupdatedAssignedTo] = useState<any>({ updated_by: selectedMilestone.updated_by });
  const commentRef = useRef<any>();
  const assignedToRef = useRef<any>();
  const [startDateAdjusted, setStartDateAdjusted] = useState<any>(selectedMilestone.start_date_adjusted);
  const [updatedStartDateAdjusted, setUpdatedStartDateAdjusted] = useState<any>({
    start_date_adjusted: selectedMilestone.start_date_adjusted,
    updated_by: userName
  });
  const [updatedEndDateAdjusted, setUpdatedEndDateAdjusted] = useState<any>({
    end_date_adjusted: selectedMilestone.end_date_adjusted,
    updated_by: userName
  });
  const [auditTrailData, setAuditTrailData] = useState<any>([]);
  const [fromData, setFromDate] = useState<any>('');
  const [toDate, setToDate] = useState<any>('');

  const [noOfAuditResults, setNoOfAuditResults] = useState(0);
  const perPage = 10;
  const [page, setPage] = useState(1);
  const [paginatedAuditDetails, setPaginatedAuditDetails] = React.useState<any>({});
  const isfLevel = 'Site';

  const handlePagination = (event: React.ChangeEvent<unknown>, pageValue: number) => {
    if (pageValue !== page) {
      setPaginationWithGroupBy(auditTrailData, pageValue);
    }
    setPage(pageValue);
  };
  const setPaginationWithGroupBy = (allAuditHistory: any[], pageNumber: number) => {
    if (allAuditHistory) {
      // const datedAudit = allAuditHistory.map((el: any) => {
      //   return {
      //     ...el,
      //     date_change: String(el.date_time_of_change).split('T')[0]
      //   };
      // });
      const begin = (pageNumber - 1) * perPage;
      const paginatedResponse = allAuditHistory.slice(begin, begin + perPage);
      setPaginatedAuditDetails(groupBy(paginatedResponse));
    } else {
      setPaginatedAuditDetails(groupBy(allAuditHistory));
    }
  };

  const groupBy = (allData: any) => {
    const listOfMilestoneUpdates: any = {};
    allData.length > 0 &&
      allData.forEach((item: any) => {
        const date = item.date_time_of_change.split('T')[0];
        if (listOfMilestoneUpdates[date]) {
          listOfMilestoneUpdates[date].push(item);
        } else {
          listOfMilestoneUpdates[date] = [item];
        }
      });
    return listOfMilestoneUpdates;
  };
  const newState = store.getState();

  const headerConfig = {
    headers: {
      sponsor: newState.user.user?.sponsor_sponsor_name,
      site_token: newState.user.user?.siteToken,
      Authorization: `Bearer ${newState.user.user?.sponsorToken}`,
      user_date_time: moment().format()
    }
  };
  const [filterDataObj, setFilterDataObj] = React.useState<any>([]);
  const [filterProps, setFilterProps] = React.useState({
    all: true,
    dataEntry: true,
    dataChange: true,
    fromDate: false,
    toDate: false,
    users: false
  });
  const [filterFromDate, setFilterFromDate] = React.useState<string | null>(null);
  const [filterToDate, setFilterToDate] = React.useState<string | null>(null);
  const [filterUsers, setFilterUsers] = React.useState<string[]>([]);
  const [sortBy, setSortBy] = React.useState('Newest');
  const maxSizeOfAuditDetails = 1000;
  const [isLoading, setIsLoading] = React.useState(false);
  const [originalAuditHistory, setOriginalAuditHistory] = React.useState<any>([]);

  const handleFilterApply = () => {
    let filterCount = 0;
    const isToDateValid =
      filterFromDate != null && filterToDate != null ? moment(filterToDate) >= moment(filterFromDate) : true;
    if (isToDateValid) {
      const tempFilters = [];
      if (filterProps.all) {
        filterCount = filterCount + 1;
        tempFilters.push({
          name: 'reason_data_changed',
          value: ['Data Change', 'Data Entry'],
          operation: 'in'
        });
      } else if (filterProps.dataChange || filterProps.dataEntry) {
        filterCount = filterCount + 1;
        if (filterProps.dataChange) {
          tempFilters.push({
            name: 'reason_data_changed',
            value: 'Data Change',
            operation: 'equals'
          });
        }
        if (filterProps.dataEntry) {
          tempFilters.push({
            name: 'reason_data_changed',
            value: 'Data Entry',
            operation: 'equals'
          });
        }
      }
      if (filterProps.fromDate) {
        if (filterFromDate) {
          filterCount = filterCount + 1;
          tempFilters.push({
            name: 'date_time_of_change',
            value: filterFromDate,
            operation: 'greater_than_or_equal'
          });
        }
      }
      if (filterProps.toDate) {
        if (filterToDate) {
          filterCount = filterCount + 1;
          tempFilters.push({
            name: 'date_time_of_change',
            value: filterToDate,
            operation: 'less_than_or_equal'
          });
        }
      }
      if (filterProps.users) {
        if (filterUsers.length) {
          filterCount = filterCount + 1;
          tempFilters.push({
            name: 'audit_user_name',
            value: filterUsers,
            operation: 'in'
          });
        }
      }
      setAppliedFilterCount(filterCount);
      setFilterDataObj(tempFilters);
      setOpenFilterSearch(false);
      getAuditHistory(
        selectedMilestone.milestone_id,
        0,
        maxSizeOfAuditDetails,
        sortBy == 'Newest' ? 'desc' : 'asc',
        tempFilters
      );
    } else {
      store.dispatch(setSnackbarMessage('To date should be less than or equal to from date.', 'error'));
    }
  };
  const handleFilterClear = () => {
    setAppliedFilterCount(0);
    setFilterDataObj([]);
    setFilterProps({
      ...filterProps,
      all: true,
      dataEntry: true,
      dataChange: true,
      fromDate: false,
      toDate: false,
      users: false
    });
    setFilterFromDate(null);
    setFilterToDate(null);
    setFilterUsers([]);
  };

  const getAuditHistory = async (
    recordId: string,
    startFrom: number,
    maxSize: number,
    sortOrder: string,
    filterData: any[]
  ) => {
    try {
      setIsLoading(true);
      if (recordId != undefined && recordId != '') {
        const options = {
          audit_module_section: 'MILESTONE TRACKING',
          row_id: recordId,
          pathVariables: {
            isOnlyUpdate: false,
            startFrom: startFrom,
            maxSize: maxSize,
            sortbyColumn: 'date_time_of_change',
            sortOrder: sortOrder
          },
          data: filterData
        };
        //Field changes
        //const fieldChangesResponse: any = await sendRequest('audit_applying_filters', options);
        const url = `${apiConfig.appConfig.apictms}/audit/applyFilter/${options.audit_module_section}/${options.row_id}/getAll?only_update=false&from=${startFrom}&size=${maxSize}&sort_by=date_time_of_change&sort_order=${sortOrder}&country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`;
        const fieldChangesResponse = await axios.post(url, [], headerConfig);
        const fieldChangesWithLabels = fieldChangesResponse.data.map((audit: any) => {
          return audit;
        });
        setNoOfAuditResults(fieldChangesWithLabels.length);
        setAuditTrailData(fieldChangesWithLabels);
        setPaginationWithGroupBy(fieldChangesWithLabels, 1);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setPaginatedAuditDetails([]);
    }
  };

  useEffect(() => {
    // if (openFieldAuditTrail) {
    getAuditHistory(
      selectedMilestone.milestone_id,
      0,
      maxSizeOfAuditDetails,
      sortBy == 'Newest' ? 'desc' : 'asc',
      filterDataObj
    );
    // }
  }, [sortBy]);

  const handleUsersChange = (event: SelectChangeEvent<typeof filterUsers>) => {
    const {
      target: { value }
    } = event;
    setFilterUsers(typeof value === 'string' ? value.split(',') : value);
    setFilterProps({ ...filterProps, users: true });
  };

  const handleSortbyChange = (e: any) => {
    setSortBy(e.target.value);
  };

  const handleStartDateAdjusted = async () => {
    if (selectedMilestone.start_date_adjusted !== updatedStartDateAdjusted.start_date_adjusted) {
      try {
        const options = {
          milestone_id: selectedMilestone.milestone_id,
          data: updatedStartDateAdjusted
        };
        //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
        const response = await axios.put(
          `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
          options.data
        );
        setEditStartDateAdjusted(false);
        setStartDateAdjusted(updatedStartDateAdjusted.start_date_adjusted);
        setUpdated(true);
        setIsUpdate(false);
        store.dispatch(setSnackbarMessage('Data Updated', 'success'));
        getData(studyId, country, siteId);
      } catch (error: any) {
        store.dispatch(setSnackbarMessage('Error saving', 'error'));
        if (error.response.status === 403) {
          store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
        } else if (error.response.status === 401) {
          store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
        }
      }
    } else {
      setEditStartDateAdjusted(false);
    }
  };
  const handleEndDateAdjusted = async () => {
    if (selectedMilestone.end_date_adjusted !== updatedEndDateAdjusted.end_date_adjusted) {
      try {
        const options = {
          milestone_id: selectedMilestone.milestone_id,
          data: updatedEndDateAdjusted
        };
        //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
        const response = await axios.put(
          `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
          options.data
        );
        setEditEndDateAdjusted(false);
        setEndDateAdjusted(updatedEndDateAdjusted.end_date_adjusted);
        setUpdated(true);
        setIsUpdate(false);
        store.dispatch(setSnackbarMessage('Data Updated', 'success'));
        getData(studyId, country, siteId);
      } catch (error: any) {
        store.dispatch(setSnackbarMessage('Date is Blank or future date entered.', 'error'));
        if (error.response.status === 403) {
          store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
        } else if (error.response.status === 401) {
          store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
        }
        store.dispatch(setSnackbarMessage('Invalid date', 'error'));
      }
    } else {
      setEditEndDateAdjusted(false);
    }
  };

  const handleAssignedToUpdate = async () => {
    const assignedValue: string = (document.getElementById('assignedToField') as HTMLInputElement).value;
    if (selectedMilestone.assigned_to !== assignedValue) {
      setAssignedTo(assignedValue);
      setupdatedAssignedTo({ ...updatedAssignedTo, assigned_to: assignedValue });
      try {
        const options = {
          milestone_id: selectedMilestone.milestone_id,
          data: { updated_by: userName, assigned_to: assignedToRef.current.value }
        };
        //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
        const response = await axios.put(
          `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
          options.data
        );
        setEditAssignedTo(false);
        setUpdated(true);
        setIsUpdate(false);
        store.dispatch(setSnackbarMessage('Data Updated', 'success'));
        getData(studyId, country, siteId);
      } catch (error: any) {
        store.dispatch(setSnackbarMessage('Error saving', 'error'));
        if (error.response.status === 403) {
          store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
        } else if (error.response.status === 401) {
          store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
        }
      }
    } else {
      setEditAssignedTo(false);
    }
  };
  const handleMilestoneStatusUpdate = async () => {
    const startDateActual = new Date(selectedMilestone.start_date_actual);
    const endDateActual = new Date(selectedMilestone.end_date_actual);
    if (selectedMilestone.milestone_status !== milestoneStatus) {
      if (milestoneStatus === 'Completed') {
        if (
          startDateActual > new Date() ||
          endDateActual > new Date() ||
          selectedMilestone.start_date_actual === null ||
          selectedMilestone.end_date_actual === null
        ) {
          setMilestoneStatus(selectedMilestone.milestone_status);
          setUpdatedMilestoneStatus({
            ...updatedMilestoneStatus,
            milestone_status: selectedMilestone.milestone_status
          });
          store.dispatch(setSnackbarMessage('Date is Blank or future date entered.', 'error'));
          setEditMilestoneStatus(false);
        } else {
          try {
            const options = {
              milestone_id: selectedMilestone.milestone_id,
              data: updatedMilestoneStatus
            };
            //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
            const response = await axios.put(
              `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
              options.data
            );
            setEditMilestoneStatus(false);
            setDisplay('none');
            setUpdated(true);
            setIsUpdate(false);
            store.dispatch(setSnackbarMessage('Data Updated', 'success'));
            getData(studyId, country, siteId);
          } catch (error: any) {
            store.dispatch(setSnackbarMessage('Error saving', 'error'));
            if (error.response.status === 403) {
              store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
            } else if (error.response.status === 401) {
              store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
            }
          }
        }
      }
      if (milestoneStatus === 'In progress') {
        if (startDateActual > new Date() || selectedMilestone.start_date_actual === null) {
          setMilestoneStatus(selectedMilestone.milestone_status);
          setUpdatedMilestoneStatus({
            ...updatedMilestoneStatus,
            milestone_status: selectedMilestone.milestone_status
          });
          store.dispatch(setSnackbarMessage('Date is Blank or future date entered.', 'error'));

          setEditMilestoneStatus(false);
        } else {
          try {
            const options = {
              milestone_id: selectedMilestone.milestone_id,
              data: updatedMilestoneStatus
            };
            //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
            const response = await axios.put(
              `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
              options.data
            );
            setEditMilestoneStatus(false);
            // setDisplay('none');
            setUpdated(true);
            setIsUpdate(false);
            store.dispatch(setSnackbarMessage('Data Updated', 'success'));
            getData(studyId, country, siteId);
          } catch (error: any) {
            store.dispatch(setSnackbarMessage('Error saving', 'error'));
            if (error.response.status === 403) {
              store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
            } else if (error.response.status === 401) {
              store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
            }
          }
        }
      }
      if (milestoneStatus === 'Planned') {
        try {
          const options = {
            milestone_id: selectedMilestone.milestone_id,
            data: updatedMilestoneStatus
          };
          //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
          const response = await axios.put(
            `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
            options.data
          );
          setEditMilestoneStatus(false);
          setUpdated(true);
          setIsUpdate(false);
          store.dispatch(setSnackbarMessage('Data Updated', 'success'));
          getData(studyId, country, siteId);
        } catch (error: any) {
          store.dispatch(setSnackbarMessage('Error saving', 'error'));
          if (error.response.status === 403) {
            store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
          } else if (error.response.status === 401) {
            store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
          }
        }
      }
      if (milestoneStatus === 'Overdue') {
        try {
          const options = {
            milestone_id: selectedMilestone.milestone_id,
            data: updatedMilestoneStatus
          };
          //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
          const response = await axios.put(
            `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
            options.data
          );
          setEditMilestoneStatus(false);
          setUpdated(true);
          setIsUpdate(false);
          store.dispatch(setSnackbarMessage('Data Updated', 'success'));
          getData(studyId, country, siteId);
        } catch (error: any) {
          store.dispatch(setSnackbarMessage('Error saving', 'error'));
          if (error.response.status === 403) {
            store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
          } else if (error.response.status === 401) {
            store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
          }
        }
      }
      if (milestoneStatus === 'Not applicable') {
        try {
          const options = {
            milestone_id: selectedMilestone.milestone_id,
            data: updatedMilestoneStatus
          };
          //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
          const response = await axios.put(
            `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
            options.data
          );
          setEditMilestoneStatus(false);
          setUpdated(true);
          setIsUpdate(false);
          store.dispatch(setSnackbarMessage('Data Updated', 'success'));
          getData(studyId, country, siteId);
        } catch (error: any) {
          store.dispatch(setSnackbarMessage('Error saving', 'error'));
          if (error.response.status === 403) {
            store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
          } else if (error.response.status === 401) {
            store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
          }
        }
      }
      if (milestoneStatus === 'On hold') {
        try {
          const options = {
            milestone_id: selectedMilestone.milestone_id,
            data: updatedMilestoneStatus
          };
          //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
          const response = await axios.put(
            `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
            options.data
          );
          setEditMilestoneStatus(false);
          setUpdated(true);
          setIsUpdate(false);
          store.dispatch(setSnackbarMessage('Data Updated', 'success'));
          getData(studyId, country, siteId);
        } catch (error: any) {
          store.dispatch(setSnackbarMessage('Error saving', 'error'));
          if (error.response.status === 403) {
            store.dispatch(setSnackbarMessage('Error 403 Restricted User permission', 'error'));
          } else if (error.response.status === 401) {
            store.dispatch(setSnackbarMessage('Error 401 Unauthorized access', 'error'));
          }
        }
      }
    } else {
      setEditMilestoneStatus(false);
    }
  };
  const handlePrint = () => {
    setPaginatedAuditDetails(groupBy(auditTrailData));
    setTimeout(() => {
      window.print();
    }, 300);
    setTimeout(() => {
      setPaginationWithGroupBy(auditTrailData, page);
    }, 300);
  };

  const handleMilestoneStatus = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMilestoneStatus(e.target.value);
    setUpdatedMilestoneStatus({ ...updatedMilestoneStatus, milestone_status: e.target.value });
    setIsUpdate(true);
  };
  const handleAssignedToChange = (e: any) => {
    setIsUpdate(true);
  };

  const [display, setDisplay] = useState('inline');

  const handleFormatDate = (value: any) => {
    return preferedDateFormat(value);
  };

  const handleTimeAmPm = (time: any) => {
    const timeString = time.slice(11, 19);
    const timeString12hr = new Date('1970-01-01T' + timeString + 'Z').toLocaleTimeString('en-US', {
      timeZone: 'UTC',
      hour12: true,
      hour: 'numeric',
      minute: 'numeric'
    });
    return timeString12hr;
  };

  const handleMilestonesDetailsNextBtn = async (tabVal: number) => {
    if (tabVal === 0 && selectedMilestone.milestone_comments === null && commentRef.current.value === '') {
      setValue(1);
    } else {
      if (tabVal === 0 && commentRef.current.value !== selectedMilestone.milestone_comments) {
        try {
          const options = {
            milestone_id: selectedMilestone.milestone_id,
            data: { milestone_comments: commentRef.current.value, updated_by: userName }
          };
          //const response: any = await sendRequest('update_milestone_by_milestoneid', options);
          const response = await axios.put(
            `${apiConfig.appConfig.apictms}/site/milestone/${selectedMilestone.milestone_id}/update?country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
            options.data
          );
          setIsUpdate(false);
          store.dispatch(setSnackbarMessage('Data Updated', 'success'));
          setValue(1);
          getData(studyId, country, siteId);
        } catch (error) {
          store.dispatch(setSnackbarMessage('Error saving', 'error'));
        }
      } else {
        if (updated === true) {
          store.dispatch(setSnackbarMessage('Data Updated', 'success'));
          setUpdated(false);
          setValue(1);
        } else {
          setValue(1);
        }
      }
      if (tabVal === 1) {
        setValue(2);
      }
      if (tabVal === 2) {
        setValue(3);
      }
      if (tabVal === 3) {
        handleClose();
      }
    }
  };
  const priorityClassName =
    (selectedMilestone.priority === 'High' && 'high') ||
    (selectedMilestone.priority === 'Medium' && 'medium') ||
    (selectedMilestone.priority === 'Low' && 'low');
  const priorityLabel =
    (selectedMilestone.priority === 'High' && 'High') ||
    (selectedMilestone.priority === 'Medium' && 'Medium') ||
    (selectedMilestone.priority === 'Low' && 'Low');
  React.useEffect(() => {
    if (selectedMilestone.milestone_status === 'Completed') {
      setDisplay('none');
    } else {
      setDisplay('inline-block');
    }
  }, [milestoneStatus]);
  const getAuditTrailData = async () => {
    try {
      const options = {
        pathVariables: {
          milestoneId: selectedMilestone.milestone_id,
          onlyUpdate: false
        }
      };
      //const response: any = await sendRequest('get_autdit_details_by_milestoneid', options);
      const response = await axios.get(
        `${apiConfig.appConfig.apictms}/audit/getAll?id=${selectedMilestone.milestone_id}&only_update=false&country_id=${country}&site_id=${siteId}&study_id=${studyId}&isf_doc_level=${isfLevel}&application=ISF&module_section_related=Milestones`,
        headerConfig
      );
      const fieldChangesWithLabels = response.data.map((audit: any) => {
        return audit;
      });
      setAuditTrailData(fieldChangesWithLabels);
      setNoOfAuditResults(fieldChangesWithLabels.length);
      setPaginatedAuditDetails(groupBy(fieldChangesWithLabels));
    } catch (error) {
      // console.log(error)
    }
  };
  useEffect(() => {
    if (value === 2) {
      getAuditTrailData();
    }
  }, [value]);
  const setFieldLabel = (field: string) => {
    if (field === 'milestone_status') return 'Milestone Status';
    else if (field === 'start_date_adjusted') return 'Start Date Adjusted';
    else if (field === 'end_date_adjusted') return 'End Date Adjusted';
    else if (field === 'assigned_to') return 'Assigned To';
    else if (field === 'milestone_comments') return 'Comments';
  };

  const [filterText, setFilterText] = useState('');
  const handleSearch = (event: any) => {
    const searchValue: string = event.target.value;
    setFilterText(searchValue);
    if (searchValue != '') {
      filterAuditList(searchValue);
    } else {
      setNoOfAuditResults(auditTrailData.length);
      setPaginationWithGroupBy(auditTrailData, 1);
      setPage(1);
    }
  };

  const filterAuditList = (value: string) => {
    const filtered = auditTrailData.filter((data: any) => {
      if (
        data.reason_data_changed?.toLowerCase().includes(value.toLowerCase()) ||
        data.field_changed?.toLowerCase().includes(value.toLowerCase()) ||
        data.field_label?.toLowerCase().includes(value.toLowerCase()) ||
        data.changed_data?.toLowerCase().includes(value.toLowerCase()) ||
        data.audit_user_name?.toLowerCase().includes(value.toLowerCase()) ||
        data.data_changed_from?.toLowerCase().includes(value.toLowerCase())
      ) {
        return data;
      }
    });
    setNoOfAuditResults(filtered.length);
    setPaginationWithGroupBy(filtered, 1);
    setPage(1);
  };
  // const listOfMilestoneUpdates: any = {};
  // auditTrailData &&
  //   auditTrailData.forEach((item: any) => {
  //     const date = item.date_time_of_change.split('T')[0];
  //     if (listOfMilestoneUpdates[date]) {
  //       listOfMilestoneUpdates[date].push(item);
  //     } else {
  //       listOfMilestoneUpdates[date] = [item];
  //     }
  //   });
  // console.log(listOfMilestoneUpdates)
  // let group = auditTrailData.reduce((r: any, a: any) => {
  //   // console.log("a", a);
  //   // console.log('r', r);
  //   r[a.date] = [...r[a.date_time_of_change] || [], a];
  //   return r;
  //  }, {});
  //  console.log("group", group);

  // const groupBy = (key : any) => {
  //   return function group(array:any) {
  //     return array.reduce((acc, obj) => {
  //       const property = obj[key];
  //       acc[property] = acc[property] || [];
  //       acc[property].push(obj);
  //       return acc;
  //     }, {});
  //   };
  // }

  // const groupByYear = groupBy("year");
  // groupByyear(albums);

  // Newly added Accordions for Audit History
  // const [expanded, setExpanded] = React.useState<string | false>(false);
  // const [expandAccords, setExpandAccords] = useState(false)
  // const [expandAccordsAll, setExpandAccordsAll] = useState(false)
  // const [activeAccordion, setActiveAccordion] = useState("")

  const [expanded, setExpanded] = React.useState<string | number | boolean>(false);
  const [expandAll, setExpandAll] = React.useState(false);

  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const handleChangeAccordion = (panelNumber: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panelNumber : false);
  };
  const handleExpandAllAccordions = () => {
    setExpandAll(!expandAll);
  };
  useEffect(() => {
    expandAll ? setExpanded(true) : setExpanded(false);
  }, [expandAll]);
  // Newly added Search Filter
  const [openFilterSearch, setOpenFilterSearch] = React.useState(false);
  const [anchorElFS, setAnchorElFS] = React.useState<null | HTMLElement>(null);

  const handleClickOpenFilterSearch = () => {
    setOpenFilterSearch(true);
  };

  const handleCloseFilterSearch = () => {
    setOpenFilterSearch(false);
  };
  const handelChange2 = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    setComments(formattedVal);
    setIsUpdate(true);
  };

  // fOR Filter modal on Search (Date Picker)
  const [category, setcategory] = React.useState('');

  const [valueFromDate, setValueFD] = React.useState<Date | null>(new Date('2022-04-20T21:11:54'));

  // const handleChangeDateFrom = (e : any, newValue: Date | null) => {
  //   // setValueFD(newValue);
  //   if(e.target.label === "To"){
  //     setToDate(newValue)
  //   }
  //   if(e.target.lable === "From"){
  //     setFromDate(newValue)
  //   }
  // };

  const [age, setAge] = React.useState('');

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value);
  };
  const headers = [
    { label: 'Date of Creation', key: 'created_on' },
    { label: 'Date of Change', key: 'date_time_of_change' },
    { label: 'Project Module', key: 'audit_project_module' },
    { label: 'Module Section', key: 'audit_module_section' },
    { label: 'User Name', key: 'audit_user_name' },
    { label: 'Field Name', key: 'field_changed' },
    { label: 'Field Data', key: 'changed_data' },
    { label: 'Previous Data', key: 'data_changed_from' },
    { label: 'Reason For Change', key: 'comments' },
    { label: 'Action Type', key: 'reason_data_changed' }
  ];
  const [appliedFilterCount, setAppliedFilterCount] = React.useState<number>(0);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [nextTabValue, setNextTabValue] = useState(value);

  useEffect(() => {
    if (value !== 0 && isUpdate) {
      setNextTabValue(value);
      setValue(0);
      setOpenConfirmExit(true);
    }
  }, [value]);
  const [csvDataDownload, setCsvDataDownload] = useState([]);

  useEffect(() => {
    const csvData = auditTrailData.map((item: any) => {
      return {
        ...item,
        date_time_of_change: moment(new Date(item.date_time_of_change))
          .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
          .toString(),
        created_on: moment(new Date(item.created_on))
          .format(`${userPreferedDateFormat.toUpperCase()} hh:mm:ss A`)
          .toString()
      };
    });
    setCsvDataDownload(csvData);
  }, [auditTrailData]);

  const [collapseItems, setCollapseItems] = useState<ICollapseItem>({});
  const handleClickExpandAll = () => {
    // setExpandAll(!expandAll);
    const expandState = getText() === expandAllTxt ? true : false;
    setCollapseItems({} as ICollapseItem);
    setExpandAll(expandState);
  };
  const handleChangeAccordions = (event: React.SyntheticEvent<Element, Event>, expanded: boolean, id: string) => {
    const newCollapse: ICollapseItem = { ...collapseItems };
    newCollapse[id] = expanded;
    setCollapseItems(newCollapse);
  };

  const getExpandAndCollapseState = (id: string): boolean => {
    let result = expandAll;
    if (collapseItems[id] !== undefined) result = collapseItems[id];
    return result;
  };

  const getText = () => {
    let txt = expandAllTxt;
    const expandedItems = Object.entries(collapseItems).filter(item => item[1] === true);
    const collapsedItems = Object.entries(collapseItems).filter(item => item[1] === false);
    txt = expandAll ? collapseAllTxt : expandAllTxt;
    if (Object.entries(collapseItems).length > 0 && (collapsedItems.length > 0 || expandedItems.length > 0)) {
      if (paginatedAuditDetails.length === collapsedItems.length) txt = expandAllTxt;
      else if (paginatedAuditDetails.length === expandedItems.length) txt = collapseAllTxt;
      else txt = expandAllTxt;
    }
    return txt;
  };

  return (
    <div>
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        {`${selectedMilestone.major_milestone} - ${selectedMilestone.minor_milestone}`}
        <Button className={`error-btn ${priorityClassName}`}>
          <ErrorIcon />
          {priorityLabel}
        </Button>
      </BootstrapDialogTitle>
      <div className="query-modal">
        <div className="card">
          <Grid container spacing={3}>
            <Grid md={12}>
              <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}>
                <Grid container>
                  <Grid md={2.3}>
                    <Tabs
                      orientation="vertical"
                      variant="scrollable"
                      value={value}
                      onChange={handleChangeUsers}
                      aria-label="Vertical tabs example"
                      sx={{ borderRight: 1, borderColor: 'divider' }}
                    >
                      <Tab label="Details" {...a11yProps(0)} />
                      <Tab label="Progress" {...a11yProps(1)} />
                      <Tab label="Associated Documents" {...a11yProps(2)} />
                      <Tab label="Audit trail" {...a11yProps(3)} />
                    </Tabs>
                  </Grid>
                  <Grid md={9.7}>
                    <TabPanel value={value} index={0} className="details-tab-content">
                      <Grid container>
                        {/* <Grid md={12}><h5>Details</h5></Grid> */}
                        <Grid container>
                          <Grid md={4}>
                            {' '}
                            <strong>Major Milestone:</strong> {selectedMilestone.major_milestone}
                          </Grid>
                          <Grid md={4}>
                            <strong>Start Date Planned Baseline:</strong>{' '}
                            {handleFormatDate(selectedMilestone.start_date_planned_baseline)}
                          </Grid>
                          <Grid md={4}>
                            {' '}
                            {editStartDateAdjusted === false ? (
                              <div style={{ position: 'relative' }}>
                                <strong>Start Date Adjusted:</strong> {handleFormatDate(startDateAdjusted)}
                                {isDisable ? (
                                  <Button
                                    //disabled={!isDisable}
                                    style={{ position: 'absolute', right: 0, top: 0, display: display }}
                                    href="#contained-buttons"
                                    className="grey-btn btn-static"
                                    onClick={() => setEditStartDateAdjusted(true)}
                                  >
                                    <EditIcon />
                                  </Button>
                                ) : (
                                  ''
                                )}{' '}
                              </div>
                            ) : (
                              <div style={{ display: 'flex', position: 'relative' }} className="date-input">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                  <Stack spacing={3}>
                                    <DatePicker
                                      label="Start Date Adjusted"
                                      inputFormat={userPreferedDateFormat}
                                      value={preferedFormatForDatePicker(startDateAdjusted)}
                                      onChange={(newValue: any) => {
                                        const changedDate = new Date(newValue).toLocaleDateString('en-CA');
                                        if (newValue === '' || newValue === null) {
                                          setUpdatedStartDateAdjusted({
                                            ...updatedStartDateAdjusted,
                                            start_date_adjusted: null
                                          });
                                        } else {
                                          // const changedDate = newValue;
                                          setStartDateAdjusted(changedDate);
                                          setUpdatedStartDateAdjusted({
                                            ...updatedStartDateAdjusted,
                                            start_date_adjusted: changedDate.length < 10 ? null : changedDate
                                          });
                                        }
                                        setIsUpdate(true);
                                      }}
                                      renderInput={(params: any) => <TextField {...params} variant="standard" />}
                                    />
                                    {/* <TextField
                                 id="startDateAdjusted"
                                 label="Start Date Adjusted"
                                 type="date"`````` 21`21
                                 defaultValue={startDateAdjusted}
                                 inputRef={startDateAdjustedRef}
                                 sx={{ width: 220 }}
                                 InputLabelProps={{
                                 shrink: true,
                                 }} */}
                                    {/* /> */}
                                  </Stack>
                                </LocalizationProvider>
                                <Button
                                  style={{ position: 'absolute', right: 0 }}
                                  href="#contained-buttons"
                                  onClick={handleStartDateAdjusted}
                                >
                                  Save
                                </Button>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid md={4}>
                            <strong>Minor Milestone:</strong> {selectedMilestone.minor_milestone}
                          </Grid>
                          <Grid md={4}>
                            <strong>Start Date Actual:</strong> {handleFormatDate(selectedMilestone.start_date_actual)}
                          </Grid>
                          <Grid md={4}>
                            {' '}
                            {editEndDateAdjusted === false ? (
                              <div style={{ display: 'flex', position: 'relative' }}>
                                {' '}
                                <p>
                                  <strong>End Date Adjusted:</strong> {handleFormatDate(endDateAdjusted)}
                                </p>
                                {isDisable ? (
                                  <Button
                                    //disabled={!isDisable}
                                    style={{ position: 'absolute', right: 0, display: display }}
                                    href="#contained-buttons"
                                    className="grey-btn btn-static"
                                    onClick={() => setEditEndDateAdjusted(true)}
                                  >
                                    <EditIcon />
                                  </Button>
                                ) : (
                                  ''
                                )}{' '}
                              </div>
                            ) : (
                              <div style={{ display: 'flex', position: 'relative' }} className="date-input">
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                  <Stack spacing={3}>
                                    <DatePicker
                                      label="End Date Adjusted"
                                      inputFormat={userPreferedDateFormat}
                                      value={preferedFormatForDatePicker(endDateAdjusted)}
                                      onChange={(newValue: any) => {
                                        const changedDate = new Date(newValue).toLocaleDateString('en-CA');
                                        if (newValue === '' || newValue === null) {
                                          setUpdatedEndDateAdjusted({
                                            ...updatedEndDateAdjusted,
                                            end_date_adjusted: null
                                          });
                                        } else {
                                          // const changedDate = newValue;
                                          setEndDateAdjusted(changedDate);
                                          setUpdatedEndDateAdjusted({
                                            ...updatedEndDateAdjusted,
                                            end_date_adjusted: changedDate.length < 10 ? null : changedDate
                                          });
                                        }
                                        setIsUpdate(true);
                                      }}
                                      renderInput={(params: any) => <TextField {...params} variant="standard" />}
                                    />
                                    {/* <TextField
                                 id="endDateAdjusted"
                                 label="End Date Adjusted"
                                 type="date"
                                 defaultValue={endDateAdjusted}
                                 inputRef={endDateAdjustedRef}
                                 sx={{ width: 220 }}
                                 InputLabelProps={{
                                 shrink: true,
                                 }}
                                 /> */}
                                  </Stack>
                                </LocalizationProvider>
                                <Button
                                  style={{ position: 'absolute', right: 0 }}
                                  href="#contained-buttons"
                                  onClick={handleEndDateAdjusted}
                                >
                                  Save
                                </Button>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid md={4}>
                            <strong>Study Stage:</strong> {selectedMilestone.study_stage}
                          </Grid>
                          <Grid md={4}>
                            <strong>End Date Planned Baseline:</strong>{' '}
                            {handleFormatDate(selectedMilestone.end_date_planned_baseline)}
                          </Grid>
                          <Grid md={4}>
                            {' '}
                            {editMilestoneStatus === false ? (
                              <div style={{ display: 'flex', position: 'relative' }}>
                                {' '}
                                <p>
                                  <strong>Milestone Status:</strong> {milestoneStatus}
                                </p>
                                {isDisable ? (
                                  <Button
                                    //disabled={!isDisable}
                                    style={{ position: 'absolute', right: 0, display: display }}
                                    href="#contained-buttons"
                                    className="grey-btn btn-static"
                                    onClick={() => setEditMilestoneStatus(true)}
                                  >
                                    <EditIcon />
                                  </Button>
                                ) : (
                                  ''
                                )}{' '}
                              </div>
                            ) : (
                              <div style={{ display: 'flex', position: 'relative' }} className="date-input">
                                <TextField
                                  // style={{width: "50%"}}
                                  select
                                  id="standard-disabled"
                                  label="Miletone Status:"
                                  name="milestone_status"
                                  variant="standard"
                                  value={milestoneStatus}
                                  defaultValue={selectedMilestone.milestone_status}
                                  onChange={handleMilestoneStatus}
                                >
                                  {milestoneStatusList.map(item => (
                                    <MenuItem key={item} value={item}>
                                      {item}
                                    </MenuItem>
                                  ))}
                                </TextField>
                                <Button
                                  sx={{ pt: 2 }}
                                  style={{ position: 'absolute', right: 0 }}
                                  href="#contained-buttons"
                                  onClick={handleMilestoneStatusUpdate}
                                >
                                  Save
                                </Button>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid md={4}>
                            <strong>Updated By:</strong> {selectedMilestone.updated_by}
                          </Grid>
                          <Grid md={4}>
                            <strong>End Date Actual:</strong> {handleFormatDate(selectedMilestone.end_date_actual)}
                          </Grid>

                          <Grid md={4}>
                            {' '}
                            {editAssignedTo === false ? (
                              <div style={{ display: 'flex', position: 'relative' }}>
                                <strong>Assigned To:</strong> {assignedTo}
                                {isDisable ? (
                                  <Button
                                    //disabled={!isDisable}
                                    style={{ position: 'absolute', right: 0, display: display }}
                                    href="#contained-buttons"
                                    className="grey-btn btn-static"
                                    onClick={() => setEditAssignedTo(true)}
                                  >
                                    <EditIcon />
                                  </Button>
                                ) : (
                                  ''
                                )}{' '}
                              </div>
                            ) : (
                              <div style={{ display: 'flex', position: 'relative' }} className="date-input">
                                <TextField
                                  id="assignedToField"
                                  label="Assigned To:"
                                  name="assigned_to"
                                  variant="standard"
                                  onChange={handleAssignedToChange}
                                  defaultValue={assignedTo}
                                  inputRef={assignedToRef}
                                  inputProps={{
                                    maxlength: 100
                                  }}
                                />
                                <Button
                                  sx={{ pt: 2 }}
                                  style={{ position: 'absolute', right: 0 }}
                                  href="#contained-buttons"
                                  onClick={handleAssignedToUpdate}
                                >
                                  Save
                                </Button>
                              </div>
                            )}
                          </Grid>
                        </Grid>
                        <Grid container>
                          <Grid md={4}>
                            <strong>Last Update:</strong>{' '}
                            {`${handleFormatDate(selectedMilestone.updated_on)} ${handleTimeAmPm(
                              selectedMilestone.updated_on
                            )}`}
                          </Grid>
                          <Grid md={4}>
                            <strong>PI Name:</strong> {selectedMilestone.pi_name}{' '}
                          </Grid>
                          <Grid md={4}>
                            <strong>Milestone Level:</strong> {selectedMilestone.milestone_level}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid md={12}>
                          <h5>Description:</h5>
                        </Grid>
                        <Grid md={12}>
                          <p>{selectedMilestone.description}</p>
                        </Grid>
                        <Grid md={12}>
                          <FormControl fullWidth margin="normal">
                            <TextField
                              disabled={true}
                              id="commentsField"
                              label="Comments"
                              variant="standard"
                              inputRef={commentRef}
                              value={comments}
                              onChange={handelChange2}
                              inputProps={{
                                maxlength: 199
                              }}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <Progress
                        selectedMilestone={selectedMilestone}
                        studyId={studyId}
                        siteId={siteId}
                        country={country}
                      />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                      <AssociatedDocuments
                        selectedMilestone={selectedMilestone}
                        studyId={studyId}
                        siteId={siteId}
                        country={country}
                      />
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                      <div className="audit-card">
                        <Grid container spacing={3}>
                          <Grid md={12}>
                            <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', pt: 0 }}>
                              <Grid container>
                                <Grid container className="search-block">
                                  <Grid md={8}></Grid>
                                  <Grid
                                    md={4}
                                    display="flex"
                                    justifyContent="flex-end"
                                    className="print-actions milestone-audit-print"
                                    id="no-print"
                                  >
                                    <Button
                                      // disabled={isDisable}
                                      onClick={() => handlePrint()}
                                      variant="text"
                                      className="grey-btn"
                                    >
                                      <LocalPrintshopIcon />
                                    </Button>
                                    <Button
                                      className="grey-btn"
                                      //disabled={auditTrailData.length === 0 || !isDisable}
                                    >
                                      {/* {auditTrailData && auditTrailData.length > 0 && ( */}
                                      <CSVLink
                                        headers={headers}
                                        data={csvDataDownload}
                                        filename={`Milestone_AuditTrail_${moment(new Date()).format(
                                          `${exportDateFormat.toUpperCase()} HH:mm:ss`
                                        )}.csv`}
                                      >
                                        <DownloadIcon />
                                      </CSVLink>
                                      {/* )} */}
                                    </Button>
                                  </Grid>
                                  <Grid md={10}>
                                    <FormControl variant="standard" sx={{ pr: 2, mt: 2 }}>
                                      <TextField
                                        id="input-with-icon-adornment"
                                        value={filterText}
                                        variant="standard"
                                        autoFocus
                                        onChange={e => handleSearch(e)}
                                        InputProps={{
                                          startAdornment: (
                                            <InputAdornment position="start">
                                              <SearchIcon />
                                            </InputAdornment>
                                          ),
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <span id="group">
                                                <IconButton
                                                  aria-label="more"
                                                  id="search-filter-IconButton"
                                                  aria-controls={openFilterSearch ? 'search-filter' : undefined}
                                                  aria-expanded={openFilterSearch ? 'true' : undefined}
                                                  aria-haspopup="true"
                                                  onClick={handleClickOpenFilterSearch}
                                                >
                                                  <TuneIcon />
                                                </IconButton>
                                                {appliedFilterCount > 0 && (
                                                  <span className="badge badge-light">{appliedFilterCount}</span>
                                                )}
                                              </span>
                                              <Menu
                                                id="search-filter"
                                                anchorEl={anchorElFS}
                                                // getContentAnchorEl={null}
                                                // keepMounted={false}
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                                open={openFilterSearch}
                                                onClose={handleCloseFilterSearch}
                                                className="FilterSMenu"
                                              >
                                                <Paper
                                                  elevation={0}
                                                  sx={{ p: 1, pl: 3, pr: 3, width: 580, maxWidth: '100%' }}
                                                  className="filterAH"
                                                >
                                                  <Typography variant="h6" component="div" sx={{ mb: 1 }}>
                                                    Filters
                                                    <Button
                                                      sx={{ mr: 2, position: 'absolute', right: 0 }}
                                                      variant="text"
                                                      href=""
                                                      onClick={handleFilterClear}
                                                    >
                                                      CLEAR
                                                    </Button>
                                                  </Typography>

                                                  <Grid container direction="row" justifyContent="space-between">
                                                    <Grid item md={5}>
                                                      <FormControl
                                                        component="fieldset"
                                                        variant="standard"
                                                        margin="normal"
                                                      >
                                                        <FormLabel component="legend" sx={{ mb: 1 }}>
                                                          Action Type
                                                        </FormLabel>
                                                        <FormGroup>
                                                          <Stack direction="column" spacing={1}>
                                                            <FormControlLabel
                                                              sx={{ ml: 0 }}
                                                              control={
                                                                <Switch
                                                                  checked={filterProps.all}
                                                                  onChange={e =>
                                                                    setFilterProps({
                                                                      ...filterProps,
                                                                      all: e.target.checked,
                                                                      dataChange: e.target.checked,
                                                                      dataEntry: e.target.checked
                                                                    })
                                                                  }
                                                                  size="small"
                                                                />
                                                              }
                                                              label="All"
                                                            />
                                                            <FormControlLabel
                                                              control={
                                                                <Switch
                                                                  checked={filterProps.dataEntry}
                                                                  onChange={e =>
                                                                    setFilterProps({
                                                                      ...filterProps,
                                                                      all: false,
                                                                      dataEntry: e.target.checked
                                                                    })
                                                                  }
                                                                  size="small"
                                                                />
                                                              }
                                                              label="Data Entry"
                                                            />
                                                            <FormControlLabel
                                                              control={
                                                                <Switch
                                                                  checked={filterProps.dataChange}
                                                                  onChange={e =>
                                                                    setFilterProps({
                                                                      ...filterProps,
                                                                      all: false,
                                                                      dataChange: e.target.checked
                                                                    })
                                                                  }
                                                                  size="small"
                                                                />
                                                              }
                                                              label="Data Change"
                                                            />
                                                          </Stack>
                                                        </FormGroup>
                                                      </FormControl>
                                                    </Grid>
                                                    <Grid item md={7}>
                                                      <FormControl fullWidth margin="normal">
                                                        <FormLabel id="" sx={{ mb: 1 }}>
                                                          Date
                                                        </FormLabel>
                                                      </FormControl>
                                                      <Grid container spacing={3} sx={{ mb: 2, display: 'flex' }}>
                                                        <Grid item md={6}>
                                                          <LocalizationProvider
                                                            dateAdapter={AdapterDateFns}
                                                            variant="standard"
                                                            className="custom-datePicker"
                                                          >
                                                            <DesktopDatePicker
                                                              label="From"
                                                              inputFormat={userPreferedDateFormat}
                                                              value={preferedFormatForDatePicker(filterFromDate)}
                                                              onChange={(newValue: any) => {
                                                                if (newValue) {
                                                                  setFilterFromDate(
                                                                    moment(
                                                                      new Date(newValue).toLocaleDateString('en-CA')
                                                                    ).format('YYYY-MM-DD HH:mm:ss.SSS')
                                                                  );
                                                                  setFilterProps({ ...filterProps, fromDate: true });
                                                                } else {
                                                                  setFilterFromDate(newValue);
                                                                  setFilterProps({ ...filterProps, fromDate: false });
                                                                }
                                                              }}
                                                              renderInput={(params: any) => (
                                                                <TextField
                                                                  {...params}
                                                                  error={false}
                                                                  variant="standard"
                                                                />
                                                              )}
                                                            />
                                                          </LocalizationProvider>
                                                        </Grid>
                                                        <Grid item md={6}>
                                                          <LocalizationProvider
                                                            dateAdapter={AdapterDateFns}
                                                            variant="standard"
                                                            className="custom-datePicker"
                                                          >
                                                            <DesktopDatePicker
                                                              label="To"
                                                              inputFormat={userPreferedDateFormat}
                                                              value={preferedFormatForDatePicker(filterToDate)}
                                                              onChange={(newValue: any) => {
                                                                if (newValue) {
                                                                  setFilterToDate(
                                                                    moment(
                                                                      new Date(newValue).toLocaleDateString('en-CA')
                                                                    ).format('YYYY-MM-DD HH:mm:ss.SSS')
                                                                  );
                                                                  setFilterProps({ ...filterProps, toDate: true });
                                                                } else {
                                                                  setFilterToDate(newValue);
                                                                  setFilterProps({ ...filterProps, toDate: false });
                                                                }
                                                              }}
                                                              renderInput={(params: any) => (
                                                                <TextField
                                                                  {...params}
                                                                  error={false}
                                                                  variant="standard"
                                                                />
                                                              )}
                                                            />
                                                          </LocalizationProvider>
                                                        </Grid>
                                                      </Grid>

                                                      <FormControl fullWidth margin="normal">
                                                        <FormLabel id="" sx={{ mb: 1 }}>
                                                          User
                                                        </FormLabel>
                                                      </FormControl>
                                                      <FormControl fullWidth variant="standard">
                                                        <InputLabel
                                                          id="filter-select-user-label"
                                                          className="smalllabel"
                                                        >
                                                          User(s)
                                                        </InputLabel>
                                                        <Select
                                                          labelId="filter-select-user-label"
                                                          id="filter-select-user"
                                                          multiple
                                                          value={filterUsers}
                                                          onChange={handleUsersChange}
                                                          input={<OutlinedInput label="User(s)" />}
                                                          MenuProps={MenuProps}
                                                        >
                                                          {usersList.map((name: string) => (
                                                            <MenuItem
                                                              key={name}
                                                              value={name}
                                                              style={getStyles(name, filterUsers, theme)}
                                                            >
                                                              {name}
                                                            </MenuItem>
                                                          ))}
                                                        </Select>
                                                      </FormControl>
                                                    </Grid>
                                                  </Grid>
                                                  <Grid container spacing={2}>
                                                    <Grid item md={12} display="flex" justifyContent="flex-end">
                                                      <Stack direction="row" spacing={2}>
                                                        <Button variant="text" href="" onClick={handleFilterApply}>
                                                          Apply
                                                        </Button>
                                                      </Stack>
                                                    </Grid>
                                                  </Grid>
                                                </Paper>
                                              </Menu>
                                            </InputAdornment>
                                          )
                                        }}
                                      />
                                    </FormControl>
                                  </Grid>
                                  <Grid md={2}>
                                    <FormControl variant="standard" sx={{ mb: 2 }}>
                                      <InputLabel id="demo-simple-select-standard-label">Sort By</InputLabel>
                                      <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        value={sortBy}
                                        onChange={e => {
                                          handleSortbyChange(e);
                                        }}
                                      >
                                        <MenuItem value="Newest">Newest</MenuItem>
                                        <MenuItem value="Oldest">Oldest</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                </Grid>

                                <Grid container>
                                  <Grid md={12} className="audit-trail-list">
                                    <Grid container>
                                      <Grid container>
                                        <Grid md={8}></Grid>
                                        <Grid
                                          id="no-print"
                                          md={4}
                                          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}
                                        >
                                          <Button onClick={handleClickExpandAll} variant="text">
                                            {getText()}
                                          </Button>
                                        </Grid>
                                      </Grid>
                                      {Object.keys(paginatedAuditDetails).length !== 0 ? (
                                        Object.keys(paginatedAuditDetails).map((item: any, index) => {
                                          return (
                                            <div key={index} className="accordion-result-section">
                                              <Grid md={12}>
                                                <Box sx={{ mb: 2 }}>
                                                  <Grid container>
                                                    <Grid md={8}>
                                                      <Typography
                                                        variant="h6"
                                                        component="div"
                                                        sx={{ mb: 1 }}
                                                        className="h6-fs16"
                                                      >
                                                        {moment(item).format('MMMM Do, YYYY')}
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                  {paginatedAuditDetails[item].map((updates: any, index: any) => {
                                                    let data = [];
                                                    if (updates.reason_data_changed.includes('Query')) {
                                                      data = JSON.parse(updates.changed_data.replace(/'/g, '"'));
                                                    }
                                                    return !updates.reason_data_changed.includes('Query') ? (
                                                      <Accordion
                                                        key={updates.id}
                                                        expanded={getExpandAndCollapseState(updates.id)}
                                                        onChange={(e, expanded) => {
                                                          handleChangeAccordions(e, expanded, updates.id);
                                                        }}
                                                        className="CustomAccordion-AH"
                                                      >
                                                        <AccordionSummary
                                                          expandIcon={<ExpandMoreIcon />}
                                                          aria-controls="panel1bh-content"
                                                          id="panel1bh-header"
                                                        >
                                                          <Box>
                                                            <Stack
                                                              spacing={1.5}
                                                              direction="row"
                                                              sx={{ alignItems: 'center', mb: 1 }}
                                                            >
                                                              <Typography variant="h6" component="div">
                                                                {`${selectedMilestone.minor_milestone}: ${updates.field_label}`}
                                                              </Typography>
                                                              <Typography variant="body2" gutterBottom>
                                                                {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
                                                                <span>{`${handleTimeAmPm(
                                                                  updates.date_time_of_change
                                                                )}`}</span>
                                                              </Typography>
                                                              <Chip
                                                                label={`${updates.reason_data_changed}`}
                                                                color="success"
                                                                size="small"
                                                              />
                                                            </Stack>
                                                            <Typography component="div" gutterBottom variant="body2">
                                                              <strong>Data Changed To:</strong>{' '}
                                                              {updates.field_changed === 'start_date_adjusted' ||
                                                              updates.field_changed === 'end_date_adjusted'
                                                                ? updates.changed_data !== 'None'
                                                                  ? handleFormatDate(updates.changed_data)
                                                                  : ''
                                                                : handleFormatDate(updates.changed_data)}
                                                            </Typography>
                                                            <Typography component="div" gutterBottom variant="body2">
                                                              <strong>Previous Value:</strong>{' '}
                                                              {updates.field_changed === 'start_date_adjusted' ||
                                                              updates.field_changed === 'end_date_adjusted'
                                                                ? updates.data_changed_from !== 'None'
                                                                  ? handleFormatDate(updates.data_changed_from)
                                                                  : ''
                                                                : updates.data_changed_from === 'None'
                                                                ? ''
                                                                : handleFormatDate(updates.data_changed_from)}
                                                            </Typography>
                                                          </Box>
                                                        </AccordionSummary>

                                                        <AccordionDetails>
                                                          <Typography component="div" gutterBottom variant="body2">
                                                            <strong>Field:</strong> {`${updates.field_label}`}
                                                          </Typography>
                                                          <Typography component="div" gutterBottom variant="body2">
                                                            <strong>Entered By:</strong> {`${updates.audit_user_name}`}
                                                          </Typography>
                                                          {/* <Typography component="div" gutterBottom variant="body2">
                                                            <strong>Reason:</strong> 
                                                          </Typography> */}
                                                        </AccordionDetails>
                                                      </Accordion>
                                                    ) : (
                                                      <Accordion
                                                        key={updates.id}
                                                        expanded={getExpandAndCollapseState(updates.id)}
                                                        onChange={(e, expanded) => {
                                                          handleChangeAccordions(e, expanded, updates.id);
                                                        }}
                                                        className="CustomAccordion-AH"
                                                      >
                                                        <AccordionSummary
                                                          expandIcon={<ExpandMoreIcon />}
                                                          aria-controls="panel1bh-content"
                                                          id="panel1bh-header"
                                                        >
                                                          <Box>
                                                            <Stack
                                                              spacing={1.5}
                                                              direction="row"
                                                              sx={{ alignItems: 'center', mb: 1 }}
                                                            >
                                                              <Typography variant="h6" component="div">
                                                                {`${selectedMilestone.minor_milestone}: ${
                                                                  updates.reason_data_changed.split('-')[1]
                                                                }`}
                                                              </Typography>
                                                              <Typography variant="body2" gutterBottom>
                                                                {`${handleFormatDate(updates.date_time_of_change)} `}{' '}
                                                                <span>{`${handleTimeAmPm(
                                                                  updates.date_time_of_change
                                                                )}`}</span>
                                                              </Typography>
                                                              <Chip
                                                                label={`${updates.reason_data_changed.split('-')[0]}`}
                                                                color="success"
                                                                size="small"
                                                              />
                                                            </Stack>
                                                          </Box>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                          <Typography component="div" gutterBottom variant="body2">
                                                            <strong>
                                                              {data.query_response
                                                                ? 'Query Responded'
                                                                : updates.reason_data_changed?.includes('Resolved')
                                                                ? 'Query Resolved'
                                                                : 'Query ID'}
                                                              :
                                                            </strong>{' '}
                                                            {data?.query_id}
                                                          </Typography>
                                                          <Typography component="div" gutterBottom variant="body2">
                                                            <strong>
                                                              {data.report_forward_to
                                                                ? 'Forwarded By'
                                                                : data.query_response
                                                                ? 'Responded By'
                                                                : data.deleted_by
                                                                ? 'Deleted By'
                                                                : updates.reason_data_changed?.includes('Resolved')
                                                                ? 'Resolved By'
                                                                : 'Raised By'}
                                                              :
                                                            </strong>{' '}
                                                            {data.updated_by ||
                                                              data.created_by ||
                                                              data.query_response ||
                                                              data.deleted_by}
                                                          </Typography>
                                                          {data.report_forward_to ||
                                                          data.query_response ||
                                                          data.created_by ? (
                                                            <>
                                                              {!data.query_response ? (
                                                                <Typography
                                                                  component="div"
                                                                  gutterBottom
                                                                  variant="body2"
                                                                >
                                                                  <strong>Send To:</strong>{' '}
                                                                  {data.report_forward_to || data.report_send_to}
                                                                </Typography>
                                                              ) : (
                                                                ''
                                                              )}
                                                              <Typography component="div" gutterBottom variant="body2">
                                                                <strong>
                                                                  {data.query_response ? 'Response' : 'Message'}:
                                                                </strong>{' '}
                                                                {data.report_comment || data.query_response}
                                                              </Typography>
                                                            </>
                                                          ) : (
                                                            ''
                                                          )}
                                                        </AccordionDetails>
                                                      </Accordion>
                                                    );
                                                  })}
                                                </Box>
                                              </Grid>
                                            </div>
                                          );
                                        })
                                      ) : (
                                        <Grid key={1}>
                                          <Box sx={{ mb: 2 }}>
                                            <span>
                                              No audit trail details found for selected milestone/field/filter criteria
                                            </span>
                                          </Box>
                                        </Grid>
                                      )}
                                      {auditTrailData.length > 0 && (
                                        <Stack spacing={2} className="siv-pagination milestone-audit-pagination">
                                          <Pagination
                                            count={Math.ceil(noOfAuditResults / perPage)}
                                            page={page}
                                            onChange={handlePagination}
                                            disabled={paginatedAuditDetails.length === 0}
                                          />
                                        </Stack>
                                      )}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>
                      </div>
                    </TabPanel>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item md={12} className="modal-footer-actions">
              <Grid container spacing={2}>
                <Grid item md={12} display="flex" justifyContent="flex-end">
                  <Stack direction="row" spacing={2}>
                    <Button href="#contained-buttons" className="grey-btn" onClick={handleClose}>
                      Close
                    </Button>
                    {value !== 3 && (
                      <Button href="#contained-buttons" onClick={() => handleMilestonesDetailsNextBtn(value)}>
                        Next
                      </Button>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        {showMsg && (
          <Snackbar
            // style={{display: showMsg ? 'visible' : 'none' }}
            open={showMsg}
            autoHideDuration={4000}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            TransitionComponent={(props: any) => <Slide {...props} direction="left" />}
            onClose={(_event, reason) => {
              if (reason === 'timeout') {
                setShowMsg(false);
              }
            }}
          >
            <Alert severity={severity ? 'success' : 'error'}>{msgDetails}</Alert>
          </Snackbar>
        )}
      </div>
      <div>
        <Dialog
          open={openConfirmExit}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
        >
          <DialogTitle id="alert-dialog-title">
            <b>Confirm Exit</b>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You have made unsaved changes. Would you like to discard them and proceed to next page?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setValue(0);
                setOpenConfirmExit(false);
              }}
              className="grey-btn"
            >
              CLOSE
            </Button>
            <Button
              onClick={() => {
                setValue(nextTabValue);
                setOpenConfirmExit(false);
                setIsUpdate(false);
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};
